import * as React from 'react';

import * as style from './styles.css';

const houseWithKey = require('../../assets/house_with_key.svg');
const home = require('../../assets/home.svg');

export const SectionOfQuestions = () => {
  return (
    <div className={style['sections']}>
      <div className={style['clients']}>
        <img className={style['home']} src={houseWithKey} />
        <div>
          <div className={style['title']}>Покупателю</div>
          <div className={style['for_clients']}>
            Узнайте рыночную стоимость, чтобы аргументированно торговаться с продавцом
          </div>
        </div>
      </div>
      <div className={style['clients']}>
        <img className={style['home']} src={home} />
        <div>
          <div className={style['title']}>Продавцу</div>
          <div className={style['for_clients']}>Назначьте объективную цену и повысьте спрос, не теряя выгоды</div>
        </div>
      </div>
    </div>
  );
};
